import React, { useState } from "react";

import Button from "../components/Button/Button";
import InputTextSlide from "../components/InputTextSlide/InputTextSlide";
import LabelSelect from "../components/LabelSelect/LabelSelect";
import Header from "../elements/Header/Header";
import Loading from "../elements/LoadingScreen/Loading";
import "../Slideshow/Slideshow.css";
import "./feedGenerator.css";
import {
  createColumnOptions,
  createCustomField,
  downloadGeneratedFeed,
  FEED_ACCEPT,
  FEED_INITIAL_MAPPING,
  FEED_INITIAL_RESULT,
  FEED_REQUIRED_FIELDS,
  FEED_REQUIRED_FIELD_LABELS,
  FEED_SET_SIZE_OPTIONS,
  handleFeedFileChange,
  submitFeedGeneration,
} from "./feedGeneratorController";

const FeedGenerator = () => {
  const [file, setFile] = useState(null);
  const [setSize, setSetSize] = useState("4");
  const [columns, setColumns] = useState([]);
  const [mapping, setMapping] = useState(FEED_INITIAL_MAPPING);
  const [customFields, setCustomFields] = useState([]);
  const [result, setResult] = useState(FEED_INITIAL_RESULT);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [infoType, setInfoType] = useState("");

  const columnOptions = createColumnOptions(columns);

  const onFileChange = async (event) => {
    const nextFile = event.target.files?.[0] || null;
    setFile(nextFile);

    await handleFeedFileChange({
      file: nextFile,
      setColumns,
      setInfo,
      setInfoType,
      setLoading,
      setMapping,
      setCustomFields,
      setResult,
    });
  };

  const updateMapping = (event) => {
    const { name, value } = event.target;
    setMapping((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const addCustomField = () => {
    setCustomFields((previous) => [...previous, createCustomField()]);
  };

  const removeCustomField = (fieldId) => {
    setCustomFields((previous) => previous.filter((field) => field.id !== fieldId));
  };

  const updateCustomField = (fieldId, key, value) => {
    setCustomFields((previous) =>
      previous.map((field) =>
        field.id === fieldId
          ? {
              ...field,
              [key]: value,
            }
          : field
      )
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    await submitFeedGeneration({
      file,
      mapping,
      customFields: customFields.map(({ name, column }) => ({ name, column })),
      setSize,
      setLoading,
      setInfo,
      setInfoType,
      setResult,
    });
  };

  return (
    <>
      <Header />
      {loading ? <Loading info="Prosze czekac, feed jest przetwarzany..." /> : null}
      <div className="slideshow feed-generator">
        <form className="slideshow__form-wrapper" onSubmit={handleSubmit}>
          <h2 className="slideshow-h2">Generator Feedow</h2>

          <input
            className="feed-generator__file-input"
            type="file"
            accept={FEED_ACCEPT}
            onChange={onFileChange}
          />

          <div className="slideshow-flex-row">
            <LabelSelect
              options={FEED_SET_SIZE_OPTIONS}
              placeholder={false}
              text="Liczba produktow w zestawie: "
              name="setSize"
              value={setSize}
              handleChange={(event) => setSetSize(event.target.value)}
            />
          </div>

          {columns.length > 0 ? (
            <div className="feed-generator__columns">
              <strong>Dostepne kolumny:</strong>
              <div className="feed-generator__columns-list">
                {columns.map((columnName) => (
                  <span key={columnName}>{columnName}</span>
                ))}
              </div>
            </div>
          ) : null}

          {columns.length > 0 ? (
            <>
              <h3 className="feed-generator__section-title">Mapowanie pol wymaganych</h3>
              <div className="feed-generator__mapping-grid">
                {FEED_REQUIRED_FIELDS.map((fieldName) => (
                  <LabelSelect
                    key={fieldName}
                    options={fieldName === "old_price"
                      ? [{ value: "", txt: "Brak" }, ...columnOptions]
                      : columnOptions}
                    placeholder={fieldName !== "old_price"}
                    text={`${FEED_REQUIRED_FIELD_LABELS[fieldName]}: `}
                    name={fieldName}
                    value={mapping[fieldName]}
                    handleChange={updateMapping}
                  />
                ))}
              </div>

              <h3 className="feed-generator__section-title">Pola dodatkowe</h3>
              <div className="feed-generator__custom-list">
                {customFields.map((field) => (
                  <div className="feed-generator__custom-row" key={field.id}>
                    <InputTextSlide
                      placeholder="Nazwa pola"
                      value={field.name}
                      text="Nazwa pola: "
                      name="customFieldName"
                      handleChange={(event) =>
                        updateCustomField(field.id, "name", event.target.value)
                      }
                    />
                    <LabelSelect
                      options={columnOptions}
                      text="Kolumna z pliku: "
                      name="customFieldColumn"
                      value={field.column}
                      handleChange={(event) =>
                        updateCustomField(field.id, "column", event.target.value)
                      }
                    />
                    <Button
                      txt="Usun pole"
                      click={() => removeCustomField(field.id)}
                      styles={{ marginBottom: "8px" }}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : null}

          <div className="feed-generator__actions">
            <Button txt="Dodaj pole dodatkowe" click={addCustomField} />
            <Button txt="Generuj" type="submit" styles={{ backgroundColor: "black" }} />
            {result.downloadUrl ? (
              <Button
                txt="Pobierz ponownie"
                click={() => downloadGeneratedFeed(result.downloadUrl, result.fileName)}
              />
            ) : null}
          </div>

          {info ? (
            <p
              className={`feed-generator__status ${
                infoType === "error"
                  ? "feed-generator__status--error"
                  : "feed-generator__status--success"
              }`}
            >
              {info}
            </p>
          ) : null}

          {result.feedId ? (
            <div className="feed-generator__result">
              <p>Feed ID: {result.feedId}</p>
              <p>Liczba zestawow: {result.sets.length}</p>
              <p>Nazwa pliku: {result.fileName}</p>
            </div>
          ) : null}
        </form>
      </div>
    </>
  );
};

export default FeedGenerator;
